(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("geojson-3d", [], factory);
	else if(typeof exports === 'object')
		exports["geojson-3d"] = factory();
	else
		root["geojson-3d"] = factory();
})(self, function() {
return 